(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-virtual-list"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-virtual-list"], factory);
	else if(typeof exports === 'object')
		exports["LunaLogcat"] = factory(require("luna-virtual-list"));
	else
		root["LunaLogcat"] = factory(root["LunaVirtualList"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__111__) {
return 